/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.getRepoStatus'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  did: /*#__PURE__*/ l.string({ format: 'did' }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  did: /*#__PURE__*/ l.string({ format: 'did' }),
  active: /*#__PURE__*/ l.boolean(),
  status: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: [
        'takendown',
        'suspended',
        'deleted',
        'deactivated',
        'desynchronized',
        'throttled',
      ]
    }>(),
  ),
  rev: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'tid' })),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get the hosting status for a repository, on this server. Expected to be implemented by PDS and Relay. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['RepoNotFound'])

export { main }

export const $lxm = $nsid
